export const PATH_HOME = "/";
export const PATH_ABOUT = "/About";
export const PATH_SERVICE = "/Service";
export const PATH_CONTACT = "/Contact";
export const PATH_APPOINTMENT = "/Appointment";